import Button from './button.vue'

const MyButton = {
  install: function (Vue) {
    Vue.component('MyButton', Button)
  }
}

export default MyButton



// WEBPACK FOOTER //
// ./src/components/button/index.js